import { am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

export const createAxes = ({
  root,
  chart,
  data,
  category,
  horizontal,
  minAxisValue,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  category: string;
  horizontal: boolean;
  minAxisValue?: number;
}) => {
  let xAxis, yAxis;

  if (!horizontal) {
    xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        paddingTop: 10,
        categoryField: category,
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 30,
        }),
      })
    );

    xAxis.data.setAll(data);

    yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        autoZoom: false,
        renderer: am5xy.AxisRendererY.new(root, {
          minGridDistance: 30,
        }),
        ...(minAxisValue !== undefined && { min: minAxisValue }),
      })
    );

    yAxis.get('renderer').labels.template.setAll({
      fontSize: 11,
    });
  } else {
    xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        autoZoom: false,
        paddingTop: 10,
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 50,
        }),
        ...(minAxisValue !== undefined && { min: minAxisValue }),
      })
    );

    yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: category,
        renderer: am5xy.AxisRendererY.new(root, {
          minGridDistance: 30,
          inversed: true,
        }),
      })
    );

    yAxis.data.setAll(data);
    xAxis.get('renderer').labels.template.setAll({
      fontSize: 11,
    });

    yAxis.get('renderer').setAll({
      cellStartLocation: 0.2,
      cellEndLocation: 0.9,
    });
  }

  return { xAxis, yAxis };
};
